import React from 'react';
import { render } from 'react-dom';
import './utils/polyfills.js';
import './utils/globals.js';
import './utils/android-focus.js';
import Router from './router/router.js';

/**
 * Entry point for application.
 */

render(<Router />, document.querySelector('#app'));



// WEBPACK FOOTER //
// ./mobile-core/src/app.js